<template>
  <v-dialog
    :value="show" 
    persistent
    max-width="750px"
    transition="dialog-transition"
    @input="closeModal"
  >
    <v-card>
      <v-card-title>
        <v-container grid-list-lg fluid py-0>
          <v-layout row wrap>
            <v-flex xs12>
              <h2>
                {{ title }}
              </h2>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-lg fluid py-0>
          <v-layout row wrap py-2>
            <v-flex xs11>
              <v-layout row wrap>
                <v-flex xs6>
                  <v-select
                    attach
                    color="black"
                    :items="allFilters"
                    v-model="selected"
                    item-text="text"
                    item-value="value"
                    label="Filtros"
                  ></v-select>
                </v-flex>
                <v-flex v-if="selected === 'minDate' || selected === 'maxDate'">
                  <v-menu
                    lazy
                    offset-y
                    full-width
                    transition="scale-transition"
                    :nudge-right="40"
                    :close-on-content-click="false"
                    v-model="dateMenu">
                    <v-text-field
                      readonly
                      slot="activator"
                      color="black"
                      class="k-orange-linear-text"
                      prepend-icon="event"
                      :value="formatDate">
                    </v-text-field>
                    <v-date-picker
                      locale="es"
                      color="k-orange-linear"
                      :key="`datepicker-date`"
                      type="date"
                      v-model="selectedValue"
                      @change="changePicker">
                    </v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs6 v-else>
                  <v-select
                    autocomplete
                    color="black"
                    item-text="name"
                    item-value="type"
                    v-model="selectedValue"
                    :items="selectedFilter"
                    :disabled="!selectedFilter.length"
                    :label="selected === '' ? '...' : getLabel()">
                  </v-select>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs1
              d-flex
              align-center
              text-xs-center>
              <v-btn
                depressed
                slot="activator"
                class="btn-add"
                :class="{ 'k-orange-linear': selected !== '' && selectedValue !== '', 'blue-grey lighten-4': selected === '' || selectedValue === '' }"
                :disabled="selected === '' || selectedValue === ''"
                @click="add">
                <v-icon>fa-check</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12>
              <vue-perfect-scrollbar :settings="settings">
                <v-container class="px-2 py-0" grid-list-lg fluid style="height: 300px;">
                  <transition-group name="fade">
                    <v-layout row wrap justify-center align-center v-for="(filter, index) in addedFilters" :key="`filter-${index}`">
                      <v-flex xs11 class="bordered">
                        <v-layout row wrap >
                          <v-flex xs2>
                            <v-icon small>fa-filter</v-icon>
                          </v-flex>
                          <v-flex xs10>
                            <v-layout row wrap>
                              <v-flex xs6>
                                {{ getText(filter) }}
                              </v-flex>
                              <v-flex xs6 text-xs-righ>
                                <template v-if="filter.key === 'solvedBy'">
                                  {{ getStatusText(filter[filter.key]) }}
                                </template>
                                <template v-else-if="filter.key.includes('Date')">
                                  {{ filter[filter.key] | formatDate }}
                                </template>
                                <template v-else-if="filter.key === 'hasAttachment'">
                                  {{ filter[filter.key] | formatFilter }}
                                </template>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs1>
                        <v-btn color="k-orange-linear" depressed small icon @click="remove(index)">
                          <v-icon small>fa-times</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </transition-group>
                </v-container>
              </vue-perfect-scrollbar>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-layout row wrap justify-end>
          <v-flex shrink>
            <v-btn flat color="black" @click="closeModal(true)">
              CANCELAR
            </v-btn>
          </v-flex>
          <v-flex shrink>
            <v-btn class="k-orange-linear-text" flat @click="applyFilter">
              FILTRAR
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import moment from 'moment';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import _ from 'lodash';
import ChannelMixin from '@/mixins/channels';

export default {
  props: {
    title: {
      type: String,
      default: 'Filtros',
    },
    show: {
      type: Boolean,
      required: true,
    },
    customFilters: {
      type: Array,
      default: () => [],
    },
    customFiltersValues: {
      type: Object,
      default: () => {},
    },
    deafultFilters: {
      type: Object,
      default: () => {},
    },
    oldFilters: {
      type: Array,
      default: () => [],
    },
  },
  mixins: [
    ChannelMixin,
  ],
  components: {
    VuePerfectScrollbar,
  },
  created() {
    this.axios.get('/chat_categories').then(({ data }) => {
      this.solvedBy = data.data;
    });
    moment.locale('es');
  },
  data() {
    return {
      dateMenu: false,
      selected: '',
      solvedBy: [],
      addedFilters: [],
      selectedValue: '',
      settings: {
        suppressScrollX: true,
      },
    };
  },
  computed: {
    allFilters() {
      const defaultFilters = [
        {
          text: 'Desde',
          value: 'minDate',
        },
        {
          text: 'Hasta',
          value: 'maxDate',
        },
        {
          text: 'Resuelto por',
          value: 'solvedBy',
        },
        ...this.customFilters,
      ];
      return defaultFilters;
    },
    allFilterValues() {
      return {
        solvedBy: this.solvedBy,
        ...this.customFiltersValues,
      };
    },
    selectedFilter() {
      if (this.selected === '') {
        return [];
      }
      return this.allFilterValues[this.selected];
    },
    formatDate() {
      const format = 'DD/MM/YYYY';
      if (this.selectedValue === '') {
        return moment().format(format);
      }
      return moment(this.selectedValue).format(format);
    },
  },
  filters: {
    formatDate(value) {
      return moment(value).format('DD/MM/YYYY');
    },
    formatFilter(value) {
      return value === 'hasAttachment' ? 'Con adjunto' : 'Sin adjunto';
    },
  },
  methods: {
    closeModal($event) {
      if ($event) {
        this.$emit('close');
      }
    },
    getLabel() {
      return this.allFilters.find(item => item.value === this.selected).text;
    },
    add() {
      const filters = this.addedFilters;
      const index = filters.findIndex(item => item[this.selected] !== undefined);
      if (index > -1) {
        filters[index][this.selected] = this.selectedValue;
      } else {
        filters.push({
          key: this.selected,
          [this.selected]: this.selectedValue,
        });
      }
      this.selected = '';
      this.selectedValue = '';
    },
    getObject(filter) {
      // return this[filter.key].find(item => filter[filter.key].includes(item.id))
      return this[filter.key].find(item => filter[filter.key] === item.id) || {};
    },
    getText(filter) {
      const text = this.allFilters.find(item => item.value === filter.key);
      if (text) {
        return text.text;
      }
      return '';
    },
    getStatusText(key) {
      return this.solvedBy.find(item => item.type === key).name;
    },
    changePicker() {
      this.dateMenu = false;
    },
    applyFilter() {
      if (this.selected !== '' && this.selectedValue !== '') {
        this.add();
      }
      this.$emit('filter', this.addedFilters.reduce((carry, item) => ({
        ...carry,
        [item.key]: item[item.key],
      }), {}));
    },
    remove(index) {
      this.addedFilters.splice(index, 1);
    },
  },
  watch: {
    selected(value) {
      if (value === 'minDate' || value === 'maxDate') {
        this.selectedValue = moment().format('YYYY-MM-DD');
      } else {
        this.selectedValue = '';
      }
    },
    oldFilters: {
      immediate: true,
      deep: true,
      handler(value) {
        const flag = value.every(item => Object.prototype.hasOwnProperty.call(item, 'key'));
        if (flag) {
          this.addedFilters = _.uniqBy([
            ...this.addedFilters,
            ...value,
          ], 'key');
        }
      },
    },
  },
};
</script>
<style scoped>
  .bordered {
    border: 1px solid #d3d3d3;
    border-radius: 6px;
  }
  .btn-add {
    margin: 0;
    padding: 0;
    min-width: 100%;
    border-radius: 6px;
  }
  .fade-enter-active, .fade-leave-active {
    transition: all .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>





// WEBPACK FOOTER //
// src/components/chat_center_v2/ModalFilters.vue